import React from 'react';

import type { Media as MediaType } from '../../../payload/payload-types';
import { GalleryBlockProps } from '@/app/_blocks/GalleryBlockGraphQL/types';
import { Media } from '../Media';

import classes from './GalleryBlock.module.scss';
import { DebugJsonBlock } from '../DebugJsonBlock';
import { Gutter } from '../Gutter';
import { renderTrademarkText } from '../TrademarkText';

export const GalleryBlock: React.FC<{
  className?: string;
  galleryBlock: GalleryBlockProps;
}> = ({ className, galleryBlock }) => {
  const image = galleryBlock.mainImage as MediaType;
  const mirror = galleryBlock.mirror;
  return (
    <Gutter>
      <div className={[className, classes.wrapper, 'grid'].filter(Boolean).join(' ')}>
        {!mirror && (
          <div className={`col-6 col-sm-12 ${classes.imageWrapper}`}>
            {image && <Media resource={image} alt={image?.alt || ''} className={classes.mainImage} imageSize='square' />}
            {(() => {
              const labelText = galleryBlock.mainImageLabel?.text || galleryBlock.mainImageLabel_legacy;
              const labelTag = galleryBlock.mainImageLabel?.tag || 'h2';
              const LabelTag = labelTag as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span' | 'p' | 'div';
              
              if (!labelText) return null;
              
              return (
                <div className={classes.itemCardLabelWrapper}>
                  <LabelTag className={classes.itemCardLabel}>{renderTrademarkText(labelText)}</LabelTag>
                </div>
              );
            })()}
          </div>
        )}
        <div className="col-6 col-sm-12 grid">
          {galleryBlock.images.map((item, index) => (
            <div key={item.id ?? index} className={`col-6 ${classes.imageWrapper}`}>
              {item.image && <Media resource={item.image} alt={(item.image as MediaType)?.alt || ''} className={classes.image} imageSize='square' />}
              {(() => {
                const labelText = item.label?.text || item.label_legacy;
                const labelTag = item.label?.tag || 'span';
                const LabelTag = labelTag as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span' | 'p' | 'div';
                
                if (!labelText) return null;
                
                return (
                  <div className={classes.itemCardLabelWrapper}>
                    <LabelTag className={classes.itemCardLabel}>{renderTrademarkText(labelText)}</LabelTag>
                  </div>
                );
              })()}
            </div>
          ))}
        </div>
        {!!mirror && (
          <div className={`col-6 col-sm-12 ${classes.imageWrapper}`}>
            {image && <Media resource={image} alt={image?.alt || ''} className={classes.mainImage} imageSize='square' />}
            {(() => {
              const labelText = galleryBlock.mainImageLabel?.text || galleryBlock.mainImageLabel_legacy;
              const labelTag = galleryBlock.mainImageLabel?.tag || 'h2';
              const LabelTag = labelTag as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span' | 'p' | 'div';
              
              if (!labelText) return null;
              
              return (
                <div className={classes.itemCardLabelWrapper}>
                  <LabelTag className={classes.itemCardLabel}>{renderTrademarkText(labelText)}</LabelTag>
                </div>
              );
            })()}
          </div>
        )}
        <DebugJsonBlock block={galleryBlock} />
      </div>
    </Gutter>
  );
};

export default GalleryBlock;
